import React, { useState, useEffect } from 'react';
import { defineMessages } from 'react-intl';
import queryString from 'query-string';
import get from 'lodash/get';

import { saveSplit, GetSplit } from 'Redux/ducks/split-test';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import tests from 'Config/split-tests';

const messages = defineMessages({
  title: {
    id: 'splittest.title',
    defaultMessage: 'Fanatical Split Tests',
  },
});

const SplitTestSwitch = ({ intl }) => {
  const [testName, setTestName] = useState(null);
  const [variantName, setVariantName] = useState(null);

  const { formatMessage } = intl;

  useEffect(() => {
    // This checks the url for split test parameters and if they exist, it changes local storage
    if (get(queryString.parse(window.location.search), 'testName', null) && get(queryString.parse(window.location.search), 'variantName', null)) {
      const testNameParam = queryString.parse(window.location.search).testName;
      const variantNameParam = queryString.parse(window.location.search).variantName;
      const existingSplit = GetSplit(testNameParam);

      // Set local storage if the test doesn't exist or if the test exists and
      // the variant is different
      if (existingSplit !== variantNameParam) {
        saveSplit(testNameParam, variantNameParam);
        // setTimeout(() => { window.location.reload(true); }, 250);
      }
      setTestName(testNameParam);
      setVariantName(variantNameParam);
    }
  }, [testName, variantName]);

  return (
    <div>
      <Meta title={formatMessage(messages.title)} />
      <NoIndex noFollow />

      <div className="SplitTestSwitch container">
        {testName && variantName &&
          <h2>
            You have switched the split test <b className="text-primary">{testName}</b> to
            variant <b className="text-primary">{variantName}</b>
          </h2>
        }
        {!testName && !variantName &&
          <h2>
            You have not provided a split test name and variant.
          </h2>
        }
        <div>
          <h4 className="mb-4">
            You can switch sides on any currently live split test below.
          </h4>

          <table className="SplitTestTable">
            <thead>
              <tr>
                <th>Split Test Name</th>
                <th>Your Current Variant</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tests.map((test) => {
                let tableTestName = test;
                if (typeof test === 'object') tableTestName = test.name;
                if (typeof test === 'object' && test.variants.length !== 2) return false;

                let status = '';
                const current = localStorage.getItem(`PUSHTELL-${tableTestName}`);
                if (current) status = current;

                return (
                  <tr key={tableTestName}>
                    <td>{tableTestName}</td>
                    <td>{status}</td>
                    <td className="SplitTestTable__actions">
                      {(!status || status === 'challenger') &&
                        <a href={`/splittest?testName=${tableTestName}&variantName=control`}>
                          Switch to control
                        </a>
                      }
                      {(!status || status === 'control') &&
                        <a href={`/splittest?testName=${tableTestName}&variantName=challenger`}>
                          Switch to challenger
                        </a>
                      }
                    </td>
                  </tr>
                );
              },
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SplitTestSwitch;
